/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const localDateRangeSchema = z.object({
  boundedOnBothEnds: z.boolean(),
  empty: z.boolean(),
  endExclusive: z.iso.date().nullish(),
  endInclusive: z.iso.date().nullish(),
  finiteAndNotEmpty: z.boolean(),
  startInclusive: z.iso.date().nullish(),
});
